module.exports = __webpack_public_path__ + "static/img/NowPlaying@3x.4fbb214.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/3x/NowPlaying@3x.png
// module id = iRSI
// module chunks = 1